<app-card-loader *ngIf="(loading$ | async)"></app-card-loader>

<ng-container *ngIf="!(loading$ | async)">

    <div class="empty-state text-center" *ngIf="!(brands | async)?.length">

      <h1 class="mt-8">You have no charities yet</h1>
      <h4>You must add one before proceeding.</h4>

    </div>

    <div class="data-list-container" *ngIf="(brands | async)?.length">

      <!-- begin::Table container -->
      <div class="table-responsive">
        <!-- begin::Table -->
        <table
          class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
        >
          <!-- begin::Table head -->
          <thead>
          <tr class="fw-bolder text-muted">
            <th class="min-w-100px">Brand</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
          </thead>
          <!-- end::Table head -->
          <!-- begin::Table body -->
          <tbody>
          <tr *ngFor="let brand of brands | async">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5" *ngIf="brand.brand_logo">
                  <img [src]="brand.brand_logo" alt=""/>
                </div>
                <div class="symbol symbol-45px me-5" *ngIf="!brand.brand_logo">
                  <img [src]="'assets/media/place.svg'" alt=""/>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <a class="text-dark fw-bolder text-hover-primary fs-5">
                    {{brand.public_name}}
                  </a>

                </div>
              </div>
            </td>
            <td align="right" class="text-right">
                <button type="button" (click)="selectBrand(brand)" class="btn btn-theme btn-xs">
                   Select Brand
                </button>
            </td>
          </tr>

          </tbody>
          <!-- end::Table body -->
        </table>
        <!-- end::Table -->
      </div>
      <!-- end::Table container -->

    </div>

</ng-container>


<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
</div>
